import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { FILTER_DIVISIONS } from 'src/app/graphql/divisions.graphql';
import { FILTER_EQUIPMENTS } from 'src/app/graphql/equipment.graphql';
import { FILTER_GATEWAYS } from 'src/app/graphql/gateways.graphql';
import { FILTER_INSTALLATION_SITE } from 'src/app/graphql/installation-site.graphql';
import { CREATE_INSTALLATION, FILTER_INSTALLATIONS, GET_DEVICE_HISTORY_LOGS, STATUS_INSTALLATION, UPDATE_INSTALLATION } from 'src/app/graphql/installations.graphql';
import { FILTER_LAMPS_TYPE } from 'src/app/graphql/lamp-type.graphql';

@Injectable({
  providedIn: 'root'
})
export class InstallationService {

  constructor(private apollo: Apollo) {
    this.company = localStorage.getItem('lastCompanySelected') ? localStorage.getItem('lastCompanySelected') : null;
  }

  /** Armazena ID da empresa selecionada **/
  private company: string | null;

  /** Algumas páginas usam essa consulta aqui. **/
  public getInstallationByReference(referenceContains: string | null, cursor: string | null = null,
    pageSize: number | null = null) {
    return this.apollo.watchQuery({
      query: FILTER_INSTALLATIONS,
      fetchPolicy: 'network-only',
      variables: {
        company: this.company,
        referenceContains: referenceContains,
        pageSize,
        cursor,
        sort_dir: "ASC",
        sort_field: "REFERENCE"
      }
    })
  }

  /** Chama a requisição do filtro de instalações **/
  public filterInstallations(
    referenceContains: string | null,
    devices: string | null = null, // Tipo de equipamento -> serialnumber
    country: string | null = null,
    state: string | null = null,
    city: string | null = null,
    district: string | null = null,
    street: string | null = null,
    cursor: string | null = null,
    pageSize: number | null = null
  ) {
    return this.apollo.watchQuery({
      query: FILTER_INSTALLATIONS,
      fetchPolicy: 'no-cache',
      variables: {
        company: this.company,
        referenceContains,
        devices,
        country,
        state,
        city,
        district,
        street,
        pageSize,
        cursor,
        sort_dir: "ASC",
        sort_field: "REFERENCE"
      }
    })
  }

  /** Chama a requisição de criação de instalações **/
  public createInstallation(
    reference: string | null,
    site: string | null,
    equipment: string | null,
    gateway: string | null,
    lampType: string | null,
    hasMagneticKey: boolean,
    applications: ['PUBLIC_LIGHTING', 'ELECTRICITY_CONSUMPTION', 'WATER_CONSUMPTION', 'GAS_CONSUMPTION'],
    division: string | null,
  ) {
    return this.apollo.mutate({
      mutation: CREATE_INSTALLATION,
      fetchPolicy: 'no-cache',
      variables: {
        company: this.company,
        reference,
        site,
        equipment,
        gateway,
        lampType,
        hasMagneticKey,
        applications,
        division,
        channel: 0
      }
    })
  }

  /**  Chama a requisição de edição de instalações **/
  public updateInstallation(
    id: string | null,
    reference: string | null,
    site: string | null,
    deviceId: string,
    gateway: string,
    applications: ['light', 'electricity', 'water', 'gas'] | null,
    isActive: boolean,
    hasMagneticKey: boolean,
    lampType: string | null,
    division: string | null
  ) {
    return this.apollo.mutate({
      mutation: UPDATE_INSTALLATION,
      fetchPolicy: 'no-cache',
      variables: {
        id,
        reference,
        site,
        deviceId,
        gateway,
        applications,
        isActive,
        hasMagneticKey,
        lampType,
        division,
        channel: 0
      }
    })
  }

  /** Chama a requisição de alteração do status inactive/active da instalação **/
  public statusInstallations(
    id: string | null,
    reference: string | null,
    isActive: boolean,
    site: string | null,
    applications: ['light', 'electricity', 'water', 'gas'] | null,
    gateway: string
  ) {
    return this.apollo.mutate({
      mutation: STATUS_INSTALLATION,
      fetchPolicy: 'network-only',
      variables: {
        id,
        reference,
        channel: 0,
        isActive,
        site,
        applications,
        gateway
      }
    })
  }

  /**Chama a requisição de filtro de equipamentos **/
  public getEquipments(
    serialNumber: string | null,
  ) {
    return this.apollo.watchQuery({
      query: FILTER_EQUIPMENTS,
      fetchPolicy: 'no-cache',
      variables: {
        company: this.company,
        serialNumber,
        cursor: null,
        pageSize: 20,
        sort_dir: "ASC",
        sort_field: "MAC_ADDRESS"
      }
    })
  }

  /** Chama a requisição do filtro de gateways da instalação **/
  public getGateways(reference: string | null) {
    return this.apollo.watchQuery({
      query: FILTER_GATEWAYS,
      fetchPolicy: 'no-cache',
      variables: {
        company: this.company,
        reference,
        sort_dir: "ASC",
        sort_field: "REFERENCE"
      }
    })
  }

  /** Chama a requisição do filtro de tipos de luminároas **/
  public getLampsType(search: string | null = null) {
    return this.apollo.watchQuery({
      query: FILTER_LAMPS_TYPE,
      fetchPolicy: 'no-cache',
      variables: {
        cursor: null,
        pageSize: 500,
        search: search
      }
    })
  }

  /** Chama a requisição do filtro de local de instalação **/
  public getInstallationsSite(
    reference: string | null,
  ) {
    return this.apollo.watchQuery({
      query: FILTER_INSTALLATION_SITE,
      fetchPolicy: 'no-cache',
      variables: {
        company: this.company,
        reference,
        sort_dir: "ASC",
        sort_field: "REFERENCE"
      }
    })
  }

  /** Chama a requisição do filtro de divisão (subprefeituras) **/
  public getDivision() {
    return this.apollo.watchQuery({
      query: FILTER_DIVISIONS,
      variables: {
        company: this.company
      }
    })
  }

  /** Chama a requisição do filtro de logs de histórico de equipamentos que passaram na instalação **/
  public getDeviceLogs(installation: string | null) {
    return this.apollo.watchQuery({
      query: GET_DEVICE_HISTORY_LOGS,
      fetchPolicy: 'network-only',
      variables: {
        installation
      }
    })
  }
}
